(function() {
  'use strict';
  angular.module('dso')
  .controller('dsoUserSearchController',['$scope', 'DsoUsers', 'secSecurityService', 'uiGridConstants', '$uibModal', '$state', '$stateParams',
    function($scope, DsoUsers, secSecurityService, uiGridConstants, $uibModal, $state, $stateParams) {
    var vm = this;
    vm.model = {};
    vm.model.userType = 'provider';
    vm.submit = submit;
    vm.add = add;
    vm.reset = reset;
    vm.running = true;
    vm.showGrid = true;
    vm.mode = "edit";
    vm.searchType = vm.model.userType;

    vm.editUnverified = function (row) {
      if (row.entity.userType === 'provider') {
        vm.editUser(row.entity);
      }
      if (row.entity.userType === 'administrator') {
        vm.showModal(row);
      }

    }

    vm.editUser = function (user) {
      if (user.userType === 'provider') {
        $state.go('dsoProviderUser', {user: user, mode: 'edit'});
      }
      if (user.userType === 'administrator') {
        let selfView = false;
        secSecurityService.getLoggedInUser().then((auth) => {
          if (auth.email) {
            selfView = auth.email === user.verifiedEmail;
          }
          $state.go('dsoAdminUser', {user: user, mode: 'edit', selfView: selfView});
        });
      }

    }

    vm.showModal = function (row) {
      let selfView = false;
      vm.gridApi.selection.selectRow(row);
      secSecurityService.getLoggedInUser().then((auth) => {
        if(auth.email) {
          selfView = auth.email === row.entity.verifiedEmail;
        }
        if(row.entity.userType == 'administrator') {
          let modalInstance = $uibModal.open({
            controllerAs: 'vm',
            controller: 'dsoAdminUserController',
            templateUrl: 'js/dso/dsoAdminUserModal.html' + appVersion,
            animation: false,
            resolve: {
              user: () => row.entity,
              mode: () => 'edit',
              selfView: selfView
            },
            size: 'lg'
          });
          modalInstance.result.then((result) => {
            if(result.add) {
              getAdmins();
            } else if(result.delete) {
              DsoUsers.deleteUser({id: row.entity.id}, function() {
                if (row.entity.userId) {
                  $scope.dnConfirmationMessage.$show('Admin '+ row.entity.userId + ' has been deleted.', 'danger');
                } else {
                  $scope.dnConfirmationMessage.$show('Admin has been deleted.', 'danger');
                }
                vm.dsoUserSearchGridOptions.data.splice(_.findIndex(vm.dsoUserSearchGridOptions.data, (user) => {
                  return user.userId === row.entity.userId;
                }), 1);
              });
            } else if(result.resend) {
              if (result.user) {
                vm.dsoUserSearchGridOptions.data[_.findIndex(vm.dsoUserSearchGridOptions.data, (user) => {
                  return user.id === result.user.id;
                })] = result.user;
              }
            } else if(result.edit) {
              getAdmins();
            } else if (result.goToMyProfile) {
              $state.go('userProfile.edit');
            }
          }, angular.noop);
        }
      });
    }

    $scope.columns = [
      { field: 'userId', displayName: 'User ID', sortingAlgorithm: sortByFirstRow, cellTemplate: '<div class="ui-grid-cell-contents">' +
        '  <a href ng-click="grid.appScope.editUser(row.entity);">{{row.entity.userId}}</a>' +
        '</div>'},
      { field: 'firstName', sortingAlgorithm: sortByFirstRow },
      { field: 'lastName', sortingAlgorithm: sortByFirstRow },
      { field: 'verifiedEmail', sortingAlgorithm: sortByFirstRow},
      { field: 'unverifiedEmail', sortingAlgorithm: sortByFirstRow, cellTemplate: '<div class="ui-grid-cell-contents">' +
      '  <a href ng-click="grid.appScope.editUnverified(row)">{{row.entity.unverifiedEmail}}</a>' +
      '</div>'},
      { field: 'status',  sortingAlgorithm: sortByFirstRow, cellFilter: 'userStatus:row.entity.status'  }];

    if(vm.model.userType && vm.model.userType !== 'administrator') {
      $scope.columns.splice(3, 0,{ field: 'getTaxId()', displayName: 'Tax ID', sortingAlgorithm: sortByFirstRow});
    }
    vm.dsoUserSearchGridOptions = {
      enableSorting: true,
      enableColumnResizing: true,
      enableRowSelection: true,
      enableFullRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      exporterMenuPdf: false,
      noUnselect: true,
      modifierKeysToMultiSelect: true,
      enableGridMenu: true,
      columnDefs: $scope.columns,
      rowTemplate: rowTemplate(),
          appScopeProvider: {
            editUnverified : (row) => { vm.editUnverified(row);},
            editUser : (user) => { vm.editUser(user);}
          },
      onRegisterApi: function(api) {
        vm.gridApi = api;
      }
    };

    if($stateParams.refresh) {
      if($stateParams.refresh === 'providers') {
        getProviders();
      }
      if($stateParams.refresh === 'admins') {
        getAdmins();
      }
    }

    submit();

    function rowTemplate() {
      return '<div ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name"'  +
          'class="ui-grid-cell" ng-class="{\'ui-grid-row-header-cell\': col.isRowHeader }" ui-grid-cell></div>';
    }
    function reset() {
      getProviders();
    }


    function submit() {
      secSecurityService.ensureActiveSession().then(() => {
        if ($scope.dsoUserSearchForm.$valid) {
          vm.dsoUserSearchGridOptions.data = [];
          var criteria = _.mapValues(vm.model, (value) => value ? value.split('*').join('%') : undefined);
          criteria.taxId && (criteria.taxId = criteria.taxId.split('-').join(''));
          secSecurityService.getLoggedInUser().then((user) => {
            user.dsoProfile = user.dsoProfile || {};
            vm.searchType = criteria.userType;
            DsoUsers.query(criteria, function(data) {
              if(data.length) {
                showOrHideTaxIdColumn();
                vm.dsoUserSearchGridOptions.data = data;
                vm.showGrid = true;
              }
              vm.running = false;
            }, function() {
              vm.running = false;
            });
          });

        }
      });
    }


    function showOrHideTaxIdColumn() {
      let userType = vm.model.userType;
      if(userType) {
        if(userType == 'administrator') {
          _.remove($scope.columns, (col) => {
            return col.displayName == 'Tax ID';
          });
        }
      }
      if(userType == 'provider') {
        let taxCol = _.find($scope.columns, (col) => {
          return col.displayName == 'Tax ID';
        });
        if(!taxCol) {
          $scope.columns.splice(3, 0,{ field: 'getTaxId()', displayName: 'Tax ID'});
        }
      }
    }

    function sortByFirstRow(a, b, rowA, rowB) {
      if(!rowA.entity.addUserMode) {
        if (a === b) return 0;
        if (a < b) return -1;
        return 1;
      }
    }

    function getAdmins() {
      vm.dsoUserSearchGridOptions.data = [];
      vm.showGrid = true;
      vm.model = {};
      vm.model.userType = 'administrator';
      submit();
    }

    function getProviders() {
      vm.dsoUserSearchGridOptions.data = [];
      vm.showGrid = true;
      vm.model = {};
      vm.model.userType = 'provider';
      submit();
    }

    function add() {
      secSecurityService.getLoggedInUser().then((user) => {
        user.dsoProfile = user.dsoProfile || {};
        var newUser = {userType: vm.model.userType, dsoProfile: {
            id: user.dsoProfile.id
          }
        };
        if(vm.searchType === 'administrator') {
          let modalInstance = $uibModal.open({
            controllerAs: 'vm',
            controller: 'dsoAdminUserController',
            templateUrl: 'js/dso/dsoAdminUserModal.html' + appVersion,
            animation: false,
            resolve: {
              user: () => newUser,
              mode: () => 'add',
              selfView: false
            },
            size: 'lg'
          });
          modalInstance.result.then(() => {
            getAdmins();
          }, angular.noop);
        }
        else {
          $state.go('dsoProviderUser', {user: newUser, mode: 'add'});
        }
      });
    }


  }]);
})();
